import { Check } from "lucide-react"
import image from "../../assets/images/whoitfor.png"
import Animator from "../../components/Aminator/Animator"
import { Link } from "react-router-dom"
import avatar from "../../assets/images/Avatar-4.png"
import avatar1 from "../../assets/images/Avatar-5.png"
import avatar2 from "../../assets/images/Avatar-6.png"
import avatar3 from "../../assets/images/Avatar-7.png"

export default function WhoItIsFor() {
    const targetAudiences = [
        "Business Analysts",
        "HR Professionals",
        "Operations Managers",
        "Admin Executives",
        "Sales & Customer Support Teams",
        "IT and Strategy Departments",
    ]

    const trainedProfessionals = [
        { id: 1, avatar: avatar, name: "Sarah J." },
        { id: 2, avatar: avatar1, name: "Michael K." },
        { id: 3, avatar: avatar2, name: "Aisha M." },
        { id: 4, avatar: avatar3, name: "David O." },
    ]

    return (
        <section className="py-16 overflow-hidden">
            <div className="px-6 md:px-20">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center max-w-6xl mx-auto">
                    {/* Left Side - Content */}
                    <div className="">
                        <Animator variant="slide" direction="right" timeout={800} delay={300} >
                            <div className="max-w-[451px] mb-6 md:mb-[49px]">
                                <h2 className="text-3xl md:text-4xl font-semibold text-[#181818] mb-4">Who This Is For</h2>
                                <p className="text-[#7F7F7F] text-lg leading-relaxed font-medium">
                                    Our programs are built for forward-thinking teams across industries:
                                </p>
                            </div>
                        </Animator>

                        {/* Target Audience List */}
                        <Animator variant="slide" direction="right" timeout={800} delay={400} >
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-[35px]">
                                {targetAudiences.map((audience, index) => (
                                    <div key={index} className="flex items-center gap-[10px]">
                                        <div className="flex-shrink-0 w-6 h-6 bg-[#F05A19] rounded-full flex items-center justify-center">
                                            <Check className="w-4 h-4 text-white" />
                                        </div>
                                        <span className="text-[#1D1B1B] font-medium">{audience}</span>
                                    </div>
                                ))}
                            </div>
                        </Animator>

                        {/* CTA Button */}
                        <Animator variant="slide" direction="right" timeout={800} delay={500} >
                            <Link to={"/sign-up"}>
                            <div className="">
                                    <button className="bg-[#322D2A] hover:bg-[#F05A19] text-white font-semibold py-2 px-4 rounded-lg transition-colors duration-200">
                                    Enroll Here
                                </button>
                            </div>
                            </Link>
                        </Animator>
                    </div>

                    {/* Right Side - Image */}
                    <div className="relative">
                        {/* E1X Academy Badge */}
                        <div className="absolute -top-10 -left-4 md:-left-16 z-10">
                            <div className="bg-white backdrop-blur-sm px-[29px] py-6 rounded-lg shadow-lg border-[#0000001A] border">
                                <div className="text-gray-900 font-bold text-sm">E1X</div>
                                <div className="text-gray-900 font-bold text-sm">Academy</div>
                            </div>
                        </div>

                        {/* Main Image */}
                        <div className=" overflow-hidden rounded-2xl">
                            <img
                                src={image}
                                alt="Professional women in business setting representing diverse teams trained by E1X Academy"
                                className="w-full h-[500px] object-cover"
                            />
                        </div>

                        {/* Trained Pro Badge */}
                        <div className="absolute -bottom-9 -right-9 bg-white backdrop-blur-sm rounded-xl p-4 shadow-lg">
                            <div className="text-center mb-3">
                                <div className="text-gray-900 font-bold text-sm">Trained Pro</div>
                            </div>

                            {/* Profile Avatars */}
                            <div className="flex items-center">
                                <div className="flex -space-x-2">
                                    {trainedProfessionals.map((professional) => (
                                        <img
                                            key={professional.id}
                                            src={professional.avatar || "/placeholder.svg"}
                                            alt={professional.name}
                                            className="w-8 h-8 rounded-full border-2 border-white object-cover"
                                        />
                                    ))}
                                </div>
                                <div className="ml-2 bg-[#F05A19] text-white text-xs font-bold px-2 py-1 rounded-full">+11</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}
